import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom'
import { EmailPasswordForm } from "./email-password-form";
import { UpdatePassword } from "./update-password";
import { TotpSetup } from "./totp-setup";
import { TotpCode } from "./totp-code";
import { ResetPassword } from "./reset-password";

interface PasswordLoginProps {
  nextStep: { signInStep?: string, resetPasswordStep?: string, totpSetupDetails: () => void}
  setNextStep: React.Dispatch<any>
}

export const PasswordLogin: React.FC<PasswordLoginProps> = ({ nextStep, setNextStep }) => {
  const [userEmail, setUserEmail] = useState("")

  const navigate = useNavigate()

  useEffect(() => {
    if (nextStep.signInStep === 'DONE') {
      // ProtectedRoutes component set the user in store
      navigate('/')
    }
  }, [nextStep, navigate])

  const getStageComponent = () => {
    if (nextStep?.resetPasswordStep === 'CONFIRM_RESET_PASSWORD_WITH_CODE'){
      return <ResetPassword userEmail={userEmail} setNextStep={setNextStep} />
    }

    switch (nextStep.signInStep) {
      case 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED':
        return <UpdatePassword setNextStep={setNextStep} />
      case 'CONTINUE_SIGN_IN_WITH_TOTP_SETUP':
        return <TotpSetup userEmail={userEmail} nextStep={nextStep} setNextStep={setNextStep} />
      case 'CONFIRM_SIGN_IN_WITH_TOTP_CODE':
        return <TotpCode setNextStep={setNextStep} />
      default:
        return <EmailPasswordForm setNextStep={setNextStep} setUserEmail={setUserEmail} />
    }
  }

  return getStageComponent()
}
